import React, { useState, lazy } from 'react';
interface ImageEntry {
  src: string;
  title: string;
  description: string;
  category: string;
}
const IMAGES: ImageEntry[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/7WWmZrChXUWRVuK1Bpmy13/image.png',
  title: 'Body Correspondences — Mirrors, Images & Holograms',
  description: 'Complete overview of direct image, reverse mirror, and direct mirror holographic correspondences across the human body. Shows upper-to-lower and hand-to-foot limb mapping systems.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8dScVNdhfJz1m28AMaERxh/WhatsApp_Image_2026-03-23_at_17.29.11.jpg',
  title: 'Scalp Acupuncture — GV Point Spinal Correspondences',
  description: 'Mapping of Governor Vessel (GV) points on the skull to spinal segments. GV24 corresponds to C1, GV22-20 to thoracic area, GV19 to L2-L5, GV18-16 to sacral area, and GV16 to coccyx.',
  category: 'Scalp Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d8vwSPfALFVCt4iVTyeGvY/WhatsApp_Image_2026-03-23_at_17.37.24.jpg',
  title: 'Governor Vessel Points — Lateral Skull View',
  description: 'Detailed anatomical view of GV points from Yamen (GV 15) through Fengfu (GV 16), Naohu (GV 17), Qiangjian (GV 18), Houding (GV 19), Qianding (GV 21), Xinhui (GV 22), to Shenting (GV 24). Includes cun measurements between points.',
  category: 'Point Location'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vgbcH7khVYPsYFquwpAzNP/WhatsApp_Image_2026-03-23_at_17.37.37.jpg',
  title: 'Scalp Zones — Side & Top Views',
  description: 'Line drawing showing the division of scalp acupuncture zones from lateral and superior perspectives. Key reference for identifying treatment areas on the head.',
  category: 'Scalp Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2PYAz361bijVw4EySa1mpr/WhatsApp_Image_2026-03-23_at_17.27.25_(31).jpg',
  title: 'Upper & Lower Limb Skeletal Correspondence',
  description: 'Skeletal comparison of the arm and leg demonstrating the holographic mirror relationship between upper and lower limbs - shoulder to hip, elbow to knee, wrist to ankle, hand to foot.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bbj5yKj4VoWsak5D37Qvok/WhatsApp_Image_2026-03-23_at_17.27.25_(30).jpg',
  title: 'Arm & Leg — Reverse Mirror Correspondence',
  description: 'Inverted leg alongside the arm showing the reverse mirror holographic relationship. Shoulder maps to foot, elbow to knee, wrist to hip The opposite of the direct image.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nKRwLkwe95QmL3V7iSTiUR/WhatsApp_Image_2026-03-23_at_17.27.25_(29).jpg',
  title: 'Bilateral Leg Skeleton — Medial & Lateral Views',
  description: 'Both legs shown side by side from medial and lateral perspectives. Useful for identifying corresponding points on the inner and outer aspects of the lower limb.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gbL1kJkRxYpAjW8Z1TBuFK/WhatsApp_Image_2026-03-23_at_17.27.25_(28).jpg',
  title: 'Bilateral Arm Skeleton — Anterior & Posterior Views',
  description: 'Both arms shown from anterior and posterior perspectives. Reference for identifying Yin and Yang surface correspondences along the upper limb.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vAhJWX7cH3QhDHZaJZ8ZsT/WhatsApp_Image_2026-03-23_at_17.27.25_(27).jpg',
  title: 'Arm Skeleton — Lateral & Medial Views',
  description: 'Single arm shown from lateral (Yang) and medial (Yin) surfaces. Key reference for locating balancing points on the hand and forearm meridians.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vEZ1vKv8g4DVk3XW8zfyBZ/WhatsApp_Image_2026-03-23_at_17.27.25_(26).jpg',
  title: 'Leg Skeleton — Reverse Mirror & Direct Views',
  description: 'Inverted and upright leg comparison demonstrating the reverse mirror holographic principle. Hip maps to foot and foot maps to hip when the limb is flipped.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sAtYFKtekScGcpF6fzApNs/WhatsApp_Image_2026-03-23_at_17.27.25_(25).jpg',
  title: 'Full Skeleton — Torso with Arm & Leg Correspondence',
  description: 'Anterior view of the upper body skeleton flanked by the arm (lateral) and leg (inverted). Demonstrates how the limbs mirror each other relative to the trunk — shoulder to hip, elbow to knee.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cJszLQxnXCuW6PBmKWkCdp/WhatsApp_Image_2026-03-23_at_17.27.25_(24).jpg',
  title: 'Full Skeleton — Reverse Mirror Arm & Leg',
  description: 'Anterior torso with the arm (palm up, posterior view) and inverted leg showing the reverse mirror holographic relationship. Hand maps to hip, shoulder maps to foot.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cFNXXodewRynHYsGqM9cKm/WhatsApp_Image_2026-03-23_at_17.27.25_(23).jpg',
  title: 'Head, Arm & Leg — Holographic Triad',
  description: 'Anterior skull view flanked by the arm and leg, illustrating the three-part holographic correspondence: head reflects the trunk, arm mirrors leg, and all share proportional joint mapping.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hqG1N1hM3zEAgwogGXKq79/WhatsApp_Image_2026-03-23_at_17.27.25_(22).jpg',
  title: 'Dorsal Hand – Acupoint Locations (LI3, TE3, SI3, 22.03)',
  description: 'Dorsal view of the hand skeleton showing key acupoints: LI3, TE3, SI3, So Jing Dian, and Master Tung point 22.03. These points are commonly used in Balance Method and Tung acupuncture for distal treatment.',
  category: 'Point Location'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gWJZ6S92Rw9uoE66GCcmvY/WhatsApp_Image_2026-03-23_at_17.27.25_(21).jpg',
  title: 'Dorsal Hand – Acupoint Locations (SI4, 22.04, 22.05, 22.06)',
  description: 'Dorsal view of the hand skeleton showing SI4 and Master Tung points 22.04, 22.05, and 22.06. These metacarpal points are used for treating neck, back, and lower limb conditions.',
  category: 'Point Location'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/azEyWja5A5kq2R7Asnsh9W/WhatsApp_Image_2026-03-23_at_17.27.25_(20).jpg',
  title: 'Dorsal Hand — Yaotong Points, SI4 & 22.05',
  description: 'Dorsal view of the hand skeleton showing Yaotong 1, 2, 3 (lumbar pain points), SI4, and Master Tung point 22.05. These points are key for treating acute and chronic low back pain via the Balance Method.',
  category: 'Point Location'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3pGLHKdGPsEs9ZERhbqiuh/WhatsApp_Image_2026-03-23_at_17.27.25_(19).jpg',
  title: 'Dorsal Hand — Mu Guan & Gu Guan Points',
  description: 'Dorsal view of the hand skeleton highlighting Mu Guan (Wood Gate) and Gu Guan (Bone Gate) points on the wrist. Used in Master Tung acupuncture for treating joint and bone conditions.',
  category: 'Point Location'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9VDYTBSS426uXB2SdccYoU/WhatsApp_Image_2026-03-23_at_17.27.25_(18).jpg',
  title: 'Plantar Foot — Calcaneal Bone Anatomy',
  description: 'Plantar view of the foot showing the calcaneus and tarsal bones. Reference for locating holographic correspondence points on the sole of the foot used in distal treatment.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/n5JgPDGq488d4xTSWEwHAp/WhatsApp_Image_2026-03-23_at_17.27.25_(17).jpg',
  title: 'Hand — Ring Finger Gall Bladder Channel Highlight',
  description: 'Dorsal view of the hand with the ring finger (4th digit) highlighted in green, indicating the Gall Bladder channel pathway. Used for identifying distal points along the Shao Yang axis.',
  category: 'Channel Mapping'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/djBoZu2tsMPBgXG7Hu1RqW/WhatsApp_Image_2026-03-23_at_17.27.25_(16).jpg',
  title: 'Plantar Foot — Second Toe Stomach Channel Highlight',
  description: 'Plantar view of the foot with the second toe highlighted in red, indicating the Stomach channel pathway. Key reference for identifying Yang Ming channel correspondences on the foot.',
  category: 'Channel Mapping'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ewgFCDxNufRvSYvfSDSEGv/WhatsApp_Image_2026-03-23_at_17.27.25_(15).jpg',
  title: 'Hand — Ring Finger Gall Bladder Channel (Dorsal View)',
  description: 'Dorsal view of the hand with the ring finger highlighted in green, showing the Gall Bladder (Shao Yang) channel pathway along the 4th digit. Used for distal point selection in Balance Method treatments.',
  category: 'Channel Mapping'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/soX1hi4g652Q9uDmo73pTp/WhatsApp_Image_2026-03-23_at_17.27.25_(14).jpg',
  title: '14 Meridians — Complete Reference Table',
  description: 'Complete table of all 14 meridians listing number, suffix abbreviation, full meridian name, and six-division family name (e.g. Hand Tai Yin, Foot Yang Ming). Includes the 12 regular meridians plus Governing Vessel (Du Mai) and Conception Vessel (Ren Mai).',
  category: 'Reference Table'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9ifm1jYrP5W5AJuvpU8CT8/WhatsApp_Image_2026-03-23_at_17.27.25_(13).jpg',
  title: "Dr. Tan's Balance Method — Systems 1–6 Matrix Table",
  description: 'Complete matrix table showing all 12 meridians and their balancing meridians across Systems 1 through 6. Each row lists a sick meridian (LU, LI, ST, SP, HT, SI, BL, KI, PC, TE, GB, LR) with its corresponding balancing meridian for each of the six systems.',
  category: 'Reference Table'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/75nPjdaL4vdyGowAuChe97/WhatsApp_Image_2026-03-23_at_17.27.25_(12).jpg',
  title: 'Four Limbs — Direct & Reverse Mirror Comparison',
  description: 'All four limb views side by side: arm (anterior), arm (posterior), leg (anterior), and leg (inverted). Demonstrates both direct image and reverse mirror holographic correspondences across upper and lower limbs.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/umJZgnxdsdFpSqw1Thpk12/WhatsApp_Image_2026-03-23_at_17.27.25_(11).jpg',
  title: 'Four Limbs — Joint Mapping Lines',
  description: 'All four limb views with connecting lines showing exact joint-to-joint holographic correspondences: hand to foot, wrist to ankle, elbow to knee, shoulder to hip. The definitive visual guide for Balance Method limb mirroring.',
  category: 'Limb Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uJPgdfCUr8DRiiE58aUEmN/WhatsApp_Image_2026-03-23_at_17.27.25_(10).jpg',
  title: 'Reverse Mirror — Arm Up & Inverted Leg with Torso Lines',
  description: 'Anterior torso with raised arm (palm forward) and inverted leg, connected by horizontal correspondence lines. Shows how hand maps to hip, wrist to thigh, elbow to knee, and shoulder to foot in the reverse mirror system.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oix9kboFEJY7weaHYAiGfM/WhatsApp_Image_2026-03-23_at_17.27.25_(9).jpg',
  title: 'Direct Image — Arm Down & Leg with Torso Lines',
  description: 'Anterior torso with arm hanging naturally and upright leg, connected by horizontal correspondence lines. Demonstrates the direct image system: shoulder to hip, elbow to knee, wrist to ankle, hand to foot.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sSej9ocsBqxN6HhcJHfe3M/WhatsApp_Image_2026-03-23_at_17.27.25_(8).jpg',
  title: 'Direct Image — Arm & Leg with Torso (Lateral View)',
  description: 'Anterior torso with arm in lateral position and leg, connected by correspondence lines. Shows the direct image holographic mapping from a slightly different angle, reinforcing joint-to-joint relationships.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/npn6pSiQUm22tsLwxLixou/WhatsApp_Image_2026-03-23_at_17.27.25_(7).jpg',
  title: 'Posterior View — Reverse Mirror Arm & Inverted Leg',
  description: 'Posterior torso with raised arm and inverted leg, connected by correspondence lines. Shows the reverse mirror holographic system from the back: hand to hip, elbow to knee, shoulder to foot.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pZyhP7UvurzrnREz37ufhu/WhatsApp_Image_2026-03-23_at_17.27.25_(6).jpg',
  title: 'Posterior View — Direct Image Arm & Leg',
  description: 'Posterior torso with arm hanging naturally and upright leg, connected by correspondence lines. Demonstrates the direct image holographic system from the back, confirming bilateral symmetry of the mapping.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/keFRx8TvE1D1acHEKeNt9z/WhatsApp_Image_2026-03-23_at_17.27.25_(5).jpg',
  title: 'Posterior Skeleton — Arm & Inverted Leg Correspondence',
  description: 'Posterior view of the full torso skeleton flanked by the arm and inverted leg. Correspondence lines connect shoulder to hip, elbow to knee, and wrist to ankle, demonstrating the reverse mirror holographic system from behind.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ctrW2R6XFj3Qw7mhgSCGb6/WhatsApp_Image_2026-03-23_at_17.27.25_(4).jpg',
  title: 'Head, Arm & Inverted Leg — Reverse Mirror Triad (Anterior)',
  description: 'Anterior skull flanked by the arm (palm up) and inverted leg with correspondence lines. Demonstrates the reverse mirror holographic triad: hand maps to hip, wrist to thigh, elbow to knee, shoulder to foot.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iePLmNWdDzCwbZ7gmN9unv/WhatsApp_Image_2026-03-23_at_17.27.25_(3).jpg',
  title: 'Head, Arm & Inverted Leg — Reverse Mirror Triad (Variant)',
  description: 'Anterior skull with arm and inverted leg showing a variant angle of the reverse mirror holographic triad. Reinforces the proportional joint mapping between upper and lower limbs relative to the head.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wDbMACrRgWCFGXt8Lx31bT/WhatsApp_Image_2026-03-23_at_17.27.25_(2).jpg',
  title: 'Head, Arm & Leg — Direct Image Triad',
  description: 'Anterior skull flanked by the arm (hanging naturally) and upright leg with correspondence lines. Shows the direct image holographic triad: shoulder to hip, elbow to knee, wrist to ankle, hand to foot.',
  category: 'Full Body Hologram'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gF7SFvkSJ79kisvEGSjtH3/WhatsApp_Image_2026-03-23_at_17.27.25_(1).jpg',
  title: 'Holographic Point Correspondences — Head & Organ Reference Table',
  description: 'Reference table mapping acupoints to head and organ correspondences. Includes LU5.5–LU6.5 for lungs, PC3 for eye, KI10 for eye, LR8 for eye, ST40/LI7.5 for nipple, LR3/LI11/ST35 for eye, and more. Essential quick-reference for Balance Method point selection.',
  category: 'Reference Table'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cxn5P6vZUYGjS1FQ3wY45r/WhatsApp_Image_2026-03-23_at_17.27.25.jpg',
  title: 'Lower Leg — LR8T & GB34T Point Locations',
  description: 'Medial and lateral views of the lower leg showing LR8T (Liver 8 Tung) on the medial side and GB34T (Gall Bladder 34 Tung) on the lateral side. Includes both skeletal and muscular anatomy for precise point location. The LR channel pathway is traced along the medial tibia.',
  category: 'Point Location'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/h9LDnPBmGQ7pwmLKLqoWqj/2026-03-23_19.22.45.jpg',
  title: 'The Third Bagua Map — Meridian & Five Element Correspondences',
  description: 'The Third Bagua acupuncture map showing the eight trigrams (Qian, Kun, Li, Kan, Zhen, Dui, Gen, Xun) with their corresponding meridians, elements, and Yin/Yang classifications. Fire (Ht, SI, Pc, SJ) at top, Water (KD, UB) at bottom. Female center: Navel (Shenque); Male center: Mingmen & Baihui.',
  category: 'Reference Table'
}];
export function HolographicImages() {
  const [lightboxIdx, setLightboxIdx] = useState<number | null>(null);
  return <div className="animate-fade" data-id="element-35">
      {/* Intro */}
      <div className="bg-bg1 border border-border rounded-[10px] shadow-md p-4 md:p-6 mb-6" data-id="element-36">
        <div className="font-sans text-[0.7rem] md:text-[0.8rem] font-extrabold tracking-[0.1em] uppercase text-teal mb-3 flex items-center gap-2 after:content-[''] after:flex-1 after:h-px after:bg-border" data-id="element-37">
          Holographic Acupuncture Reference
        </div>
        <p className="text-[0.85rem] md:text-[0.95rem] text-ink3 leading-relaxed" data-id="element-38">
          Dr. Tan's Balance Method uses{' '}
          <b className="text-ink" data-id="element-39">holographic imaging</b> — the principle that
          each part of the body contains a map of the whole. These reference
          images illustrate the <b className="text-ink" data-id="element-40">mirror</b>,{' '}
          <b className="text-ink" data-id="element-41">image</b>, and{' '}
          <b className="text-ink" data-id="element-42">holographic correspondences</b> used to locate
          distal treatment points. Click any image to view full size.
        </p>
      </div>

      {/* Image Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-43">
        {IMAGES.map((img, i) => <div key={i} className={`bg-bg1 border border-border rounded-[10px] overflow-hidden shadow-sm cursor-pointer transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 ${i === 0 ? 'md:col-span-2' : ''}`} onClick={() => setLightboxIdx(i)} data-id="element-44">
            <div className={`relative bg-white flex items-center justify-center overflow-hidden ${i === 0 ? 'h-[250px] md:h-[420px]' : 'h-[220px] md:h-[320px]'}`} data-id="element-45">
              <img src={img.src} alt={img.title} className="w-full h-full object-contain p-2" loading="lazy" data-id="element-46" />
            </div>
            <div className="p-3 md:p-4 border-t border-border" data-id="element-47">
              <div className="flex items-start gap-2 mb-1.5" data-id="element-48">
                <span className="text-[0.58rem] md:text-[0.62rem] font-bold tracking-[0.06em] uppercase bg-teal-p text-teal border border-teal/20 py-0.5 px-2 rounded-md whitespace-nowrap shrink-0" data-id="element-49">
                  {img.category}
                </span>
              </div>
              <div className="text-[0.9rem] md:text-[1rem] font-bold text-ink leading-snug mb-1.5" data-id="element-50">
                {img.title}
              </div>
              <div className="text-[0.78rem] md:text-[0.84rem] text-ink3 leading-relaxed" data-id="element-51">
                {img.description}
              </div>
            </div>
          </div>)}
      </div>

      {/* Lightbox */}
      {lightboxIdx !== null && <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4 md:p-8" onClick={() => setLightboxIdx(null)} data-id="element-52">
          <div className="relative max-w-[95vw] max-h-[90vh] bg-white rounded-lg overflow-hidden shadow-lg" onClick={e => e.stopPropagation()} data-id="element-53">
            <img src={IMAGES[lightboxIdx].src} alt={IMAGES[lightboxIdx].title} className="max-w-full max-h-[80vh] object-contain" data-id="element-54" />
            <div className="p-3 md:p-4 border-t border-border bg-bg2" data-id="element-55">
              <div className="text-[0.9rem] md:text-[1rem] font-bold text-ink mb-1" data-id="element-56">
                {IMAGES[lightboxIdx].title}
              </div>
              <div className="text-[0.75rem] md:text-[0.82rem] text-ink3" data-id="element-57">
                {IMAGES[lightboxIdx].description}
              </div>
            </div>

            {/* Close button */}
            <button onClick={() => setLightboxIdx(null)} className="absolute top-2 right-2 w-8 h-8 md:w-9 md:h-9 rounded-full bg-bg0/80 text-white flex items-center justify-center text-lg font-bold cursor-pointer border-none hover:bg-bg0 transition-colors" data-id="element-58">
              ✕
            </button>

            {/* Nav arrows */}
            {lightboxIdx > 0 && <button onClick={e => {
          e.stopPropagation();
          setLightboxIdx(lightboxIdx - 1);
        }} className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-bg0/60 text-white flex items-center justify-center text-lg font-bold cursor-pointer border-none hover:bg-bg0/90 transition-colors" data-id="element-59">
                ‹
              </button>}
            {lightboxIdx < IMAGES.length - 1 && <button onClick={e => {
          e.stopPropagation();
          setLightboxIdx(lightboxIdx + 1);
        }} className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-bg0/60 text-white flex items-center justify-center text-lg font-bold cursor-pointer border-none hover:bg-bg0/90 transition-colors" data-id="element-60">
                ›
              </button>}
          </div>
        </div>}
    </div>;
}